import React from 'react';

export const ShowHideChannelsIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.6375 2.8125H4.4625C4.4625 2.8125 5.2875 2.8125 5.2875 3.6375V14.3625C5.2875 14.3625 5.2875 15.1875 4.4625 15.1875H3.6375C3.6375 15.1875 2.8125 15.1875 2.8125 14.3625V3.6375C2.8125 3.6375 2.8125 2.8125 3.6375 2.8125Z"
      stroke="#4A61E8"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.58804 2.8125H9.41304C9.41304 2.8125 10.238 2.8125 10.238 3.6375V14.3625C10.238 14.3625 10.238 15.1875 9.41304 15.1875H8.58804C8.58804 15.1875 7.76304 15.1875 7.76304 14.3625V3.6375C7.76304 3.6375 7.76304 2.8125 8.58804 2.8125Z"
      stroke="#4A61E8"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5375 2.8125H14.3625C14.3625 2.8125 15.1875 2.8125 15.1875 3.6375V14.3625C15.1875 14.3625 15.1875 15.1875 14.3625 15.1875H13.5375C13.5375 15.1875 12.7125 15.1875 12.7125 14.3625V3.6375C12.7125 3.6375 12.7125 2.8125 13.5375 2.8125Z"
      stroke="#4A61E8"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
